<template></template>
<script>
import { ref } from "vue";
import { toast } from "vue3-toastify";
import { parse } from "wellknown";
import Timer from "@/utils/Timer";
import API from "@/utils/API";
import Map from "@/utils/Map";

import { StartConfigDevice, StartVideoResult } from "@/utils/Utils.js";
import { useDevicesStore } from "@/stores/devicesStore.js";
import LiveUpdateJSON from "@/utils/debug/liveupdate.json";

import Action_Toast from "@/partials/Action_Toast.vue";

export default {
  name: "Device_App",
  components: {},
  setup() {
    return {
      devices: ref({}),
      clock: ref(0),
    };
  },

  beforeCreate() {
    this.$root.devices = {
      devices: {},
      online: {},
      offline: {},
      online_compteur: {
        number: 0,
        sitOnline: {},
      },
      externe: {},
      easyParser: {},
      aeroscope: [],
      relaod: false,
      firstParseLoaded: false,
    };

    this.$root.action = {};
  },

  async mounted() {
    // [AJOUT] Récupération du store Pinia
    const devicesStore = useDevicesStore();
    this.devicesStore = devicesStore;

    await this.traitementDevices();
    this.init();

    //[AJOUT] Synchronisation initiale
    this.devicesStore.setDevices(this.$root.devices);

    Timer.addRequest("liveupdate", {
      timer: this.init,
    });
  },

  methods: {
    async init() {
      if (this.$root.devices.relaod) return;
      this.$root.devices.relaod = true;

      let api_devices = 1;
      let api_videoStream = 1;
      let api_aware = 1;
      let api_mapElements = 0;
      let api_contacts = 0;
      let actionpending = 0;

      if (this.clock % 5 == 0) {
        api_mapElements = 1;
      }
      if (this.clock % 5 == 0) {
        actionpending = 1;
      }
      if (this.clock % 30 == 0) {
        api_contacts = 1;
      }

      let live_update = await API.get("liveupdate", {
        devices: api_devices,
        mapElement: api_mapElements,
        aware: api_aware,
        contacts: api_contacts,
        videoStream: api_videoStream,
        actionpending: actionpending,
        debug: this.$root.query.hasOwnProperty("DebugLiveUpdate")
          ? "true"
          : "false",
      });

      this.clock++;
      /* ----- DEVICES ----- */

      live_update = this.debugDevices(live_update);

      await this.updateDevices(live_update?.devices);
      /* ----- MAP ELEMENTS ----- */

      this.updateMapElement(live_update?.mapElement);

      /* ----- AWARE ELEMENTS ----- */

      this.updateAware(live_update?.aware);

      /* ----- CONTACT ----- */

      this.updateContact(live_update?.contacts);

      /* ----- VIDEO STREAM ----- */

      this.updateVideoStream(live_update?.videoStream);

      /* ----- ACTION PENDING ----- */
      if (live_update?.action_pending != undefined) {
        this.traitementActionPending(live_update?.action_pending);
      }

      this.$root.devices.relaod = false;

      // [AJOUT] On recopie dans Pinia après avoir tout modifié
      this.devicesStore.setDevices(this.$root.devices);
    },

    /** ------------------------------------------- */

    traitementActionPending(action_pending) {
      if (action_pending == undefined) return;
      if (action_pending.length == 0) return;

      action_pending.forEach((action) => {
        if (this.$root.action.hasOwnProperty(action.ach_id)) {
          return;
        }

        action.toast = toast(Action_Toast, {
          type: "warning",
          expandCustomProps: true,
          autoClose: false,
          closeOnClick: false,
          position: toast.POSITION.TOP_LEFT,
          toastClassName: "toast-action-pending",
          pauseOnFocusLoss: false,
          theme: "dark",
          contentProps: {
            action: action,
          },
        });

        this.$root.action[action.ach_id] = action;
      });
    },

    /** ------------------------------------------- */

    async traitementDevices() {
      let devices = await API.get("device", {});

      devices = devices.filter((device) => {
        return !device.dev_sn.includes(ENV.DELETED);
      });

      devices.forEach(async (device) => {
        if (device.dev_family != null) {
          let keys = Object.keys(device.dev_family);

          keys.forEach((key) => {
            this.$root.devices.easyParser[device.dev_family[key]] =
              device.dev_id;
          });
        }

        if (
          this.IfOnSite(device.sit_id) &&
          this.$root?.device_controller_without_slave?.hasOwnProperty(
            device.det_id
          ) &&
          !this.$root.device_aeroscope.hasOwnProperty(device.det_id)
        ) {
          this.$root.devices.externe[device.dev_id] = device;
        } else if (
          this.IfOnSite(device.sit_id) &&
          this.$root.device_aeroscope.hasOwnProperty(device.det_id)
        ) {
          this.$root.devices.aeroscope[device.dev_id] = device;
        }

        this.$root.devices.devices[device.dev_id] = device;
        this.$root.devices.offline[device.dev_id] = device;

        // await this.InitDataDevice(this.$root.devices.devices[device.dev_id]);
      });
    },

    async updateDevices(devices) {
      if (devices == undefined) return;

      let keys = Object.keys(devices);

      if (keys.length == 0) return;

      let online = 0;
      this.$root.devices.online_compteur.sitOnline = {};

      keys.forEach(async (key) => {
        let device = devices[key];
        device.dev_id = parseInt(key);
        await this.device_parse(device);

        if (
          this.$root.devices.online_compteur.sitOnline[device.siteId] ==
          undefined
        ) {
          this.$root.devices.online_compteur.sitOnline[device.siteId] = {
            online: 0,
            total: 0,
          };
        }

        this.$root.devices.online_compteur.sitOnline[device.siteId].total++;

        if (device.online) {
          online++;
          this.$root.devices.online_compteur.sitOnline[device.siteId].online++;
        }
      });

      this.$root.devices.online_compteur.number = online;
      this.$root.devices.firstParseLoaded = true;
    },

    async device_parse(device) {
      if (!device.online) {
        // TODO !this.IfOnSite(device.sit_id)
        this.goOffline(device);
        return;
      }

      await this.goOnline(device);

      if (device?.rawStatus != undefined) {
        let on = this.$root.devices.easyParser[device.dev_id];
        let fromController = false;

        if (
          this.$root.devices.online[on]?.config?.dock !== undefined &&
          this.$root.devices.online[on]?.config?.dock !== false
        ) {
          fromController = "dock";
        } else if (
          this.$root.devices.online[on]?.config?.rcPlus !== undefined &&
          this.$root.devices.online[on]?.config?.rcPlus !== false
        ) {
          fromController = "rcPlus";
        }

        if (on != undefined) {
          let deviceRaw = {};
          let keys = Object.keys(device.rawStatus);

          keys.forEach((key) => {
            deviceRaw = {
              ...deviceRaw,
              ...device.rawStatus[key],
            };
          });

          if (__DEV__) {
            if (
              device?.type == "drone" &&
              this.$root.query.hasOwnProperty("CustomMeasureTarget")
            ) {
              deviceRaw["80-0-0"].measure_target_longitude = 7.07482265;
              deviceRaw["80-0-0"].measure_target_latitude = 43.62296997;
              deviceRaw["80-0-0"].measure_target_altitude = 201.9948596296392;
              deviceRaw["80-0-0"].measure_target_distance = 250.0;
              deviceRaw["80-0-0"].measure_target_error_state = 0;
            }
          }

          deviceRaw.LastPing = device.lastPing;
          device.rawStatus = deviceRaw;

          if (this.$root.devices.online[on] == undefined) return;

          this.$root.devices.online[on].config[device.type].status =
            device.rawStatus;

          /** ------------------------- */
          this.VideosInfo(this.$root.devices.online[on]);

          /** ------------------------- */

          if (device?.type == "dock" || device?.type == "rcPlus") {
            this.$root.devices.online[on].config.isDock = device.type == "dock";
          }

          /** ------------------------- */

          if (device?.type == "drone") {
            await this.CamDrone(
              this.$root.devices.online[on],
              this.$root.devices.online[on].config.drone.status
            );
          }

          if (device?.type == "dock") {
            this.Camera(
              this.$root.devices.online[on],
              device?.deviceVideoStatus
            );

            if (
              device?.currentFlight?.flg_id != undefined &&
              !Number.isInteger(device?.config?.flight?.id)
            ) {
              if (this.$root.devices.online[on]?.config?.FlightInit == false) {
                this.$root.devices.online[on]?.config?.FlightInit == true;
                await this.FlightCurrent(this.$root.devices.online[on], device);
                await this.Mission(this.$root.devices.online[on]);
              }
            }

            await this.Flight(this.$root.devices.online[on], device);
          }

          /** ------------------------- */

          if (device?.hms?.length > 0) {
            if (device.type == "dock" || device.type == "rcPlus") {
              this.$root.devices.online[on].config.HMS.errorHMS.dock =
                device.hms;
            } else {
              this.$root.devices.online[on].config.HMS.errorHMS[
                fromController
              ] = device.hms;
            }
          }

          this.$root.devices.online[on].config.loaded = true;
        }
      } else {
      }
    },

    async goOnline(device) {
      if (this.$root.devices.online[device.dev_id] == undefined) {
        this.$root.devices.devices[device.dev_id].type = device.type;

        if (
          device.type == "dock" ||
          device.type == "rcPlus" ||
          device.type == "other"
        ) {
          await this.InitDataDevice(this.$root.devices.devices[device.dev_id]);

          this.$root.devices.online[device.dev_id] =
            this.$root.devices.devices[device.dev_id];
        } else if (device.type == "watchcam") {
          /** WATCHCAM */
          let on = this.$root.devices.easyParser[device.dev_id];

          if (on == undefined) return;
          if (this.$root.devices.online[on] == undefined) return;

          this.$root.devices.online[on].config.webcam.online = device.online;
        } else if (device.type == "device_rtmp") {
          /** Device Externe */
          await this.InitDataDevice(this.$root.devices.devices[device.dev_id]);

          this.$root.devices.online[device.dev_id] =
            this.$root.devices.devices[device.dev_id];

          console.log(this.$root.devices.devices[device.dev_id]);
          this.$root.devices.online[device.dev_id].config.infoType =
            "device_externe";
          this.$root.devices.online[device.dev_id].loaded = true;
        }
      }

      if (this.$root.devices.offline[device.dev_id] != undefined) {
        delete this.$root.devices.offline[device.dev_id];
      }
    },

    goOffline(device) {
      if (this.$root.devices.online[device.dev_id] != undefined) {
        delete this.$root.devices.online[device.dev_id];
      }

      if (device.type == "watchcam") {
        let on = this.$root.devices.easyParser[device.dev_id];

        if (on == undefined) return;
        if (this.$root.devices.online[on] == undefined) return;

        if (
          this.$root.devices.online[on]?.config?.webcam?.online !== undefined
        ) {
          this.$root.devices.online[on].config.webcam.online = device.online;
        }

        this.$root.devices.online[on].config.videos.forEach((video) => {
          if (video.isWebcam) video.open = false;
        });
      }

      if (device.type == "dock" || device.type == "rcPlus") {
        this.clearFlight(this.$root.devices.devices[device.dev_id]);
      }

      if (device.type == "drone") {
        let on = this.$root.devices.easyParser[device.dev_id];

        if (on == undefined) return;
        if (this.$root.devices.online[on] == undefined) return;

        this.$root.devices.online[on].config.drone.status = {};
      }

      if (this.$root.devices.offline[device.dev_id] == undefined) {
        this.$root.devices.offline[device.dev_id] =
          this.$root.devices.devices[device.dev_id];
      }
    },

    updateMapElement(mapElements) {
      if (this.$root.isPilotLogin) return;
      if (!this.$root.mapJsLoaded) return;
      if (!this.$root.mainMapReady) return;
      if (mapElements == undefined) return;
      if (mapElements.length == 0) return;

      // TODO : Utiliser une fonction global (Map.vue)
      Map.element.scanElements(mapElements); // may be good
    },

    updateAware(awareElements) {
      if (this.$root.isPilotLogin) return;
      if (!this.$root.mainMapReady) return;
      if (!this.$root.mapJsLoaded) return;
      if (awareElements == undefined) return;
      if (awareElements?.length == 0) return;
      if (awareElements[0]?.awa_text == undefined) return;

      // TODO : Utiliser une fonction global (Map.vue)
      awareElements = awareElements[0].awa_text.filter((aware) => {
        if (this.$root?.devices?.online == undefined) return true;

        let r = true;

        for (let key in this.$root.devices.online) {
          if (
            Object.prototype.hasOwnProperty.call(this.$root.devices.online, key)
          ) {
            let device = this.$root.devices.online[key];

            if (device?.config?.deviceFamilly?.this_dev_sn) {
              if (aware.sn.includes(device.config.deviceFamilly.this_dev_sn)) {
                r = false;
              }
            }
            if (device?.config?.deviceFamilly?.drone_dev_sn) {
              if (aware.sn.includes(device.config.deviceFamilly.drone_dev_sn)) {
                r = false;
              }
            }
          }
        }
        return r;
      });

      Map.element.scanAware(awareElements);
    },

    updateContact(contacts) {
      if (contacts == undefined) return;
      if (contacts.length == 0) return;

      let current_ID = $root.user.getId();
      let r = [];

      Object.keys(contacts).forEach((key) => {
        if (current_ID == key) return;
        contacts[key].id = key;
        r.push(contacts[key]);
      });

      this.$root.global.contactOnline = r;
    },

    updateVideoStream(videoStream) {
      if (videoStream == undefined) return;
      this.$root.videoStream = videoStream;
    },

    /** ------------------- */

    IfOnSite(sit_id) {
      return (
        this.$root?.global?.site == undefined ||
        (this.$root?.global?.site?.sit_id != undefined &&
          this.$root?.global?.site?.sit_id == sit_id)
      );
    },

    /** ------------------- */

    async FlightCurrent(device, deviceLiveUpdate) {
      let flightcurrent = deviceLiveUpdate?.currentFlight;

      device.config.flight.id = flightcurrent.cmd_id;
      device.config.flight.flg_id = flightcurrent.flg_id;
      device.config.flight.flr_id = flightcurrent.flr_id;

      let flight_info = API.getFirstData(
        await API.get("flight", {
          // flightdetails
          FlgId: device.config.flight.flg_id,
        })
      );

      device.config.flight = {
        ...device.config.flight,
        ...flight_info,
      };

      if (device.config.flight?.flg_safeheight == undefined) {
        if (device.config.flight?.flg_safeheight == undefined) {
          device.config.flight.flg_safeheight = 50;
        }

        if (device.config.flight?.flg_battmin == undefined) {
          device.config.flight.flg_battmin = 50;
        }
      }
    },

    async Flight(device, deviceLiveUpdate) {
      if (deviceLiveUpdate.type != "dock") return;
      if (device?.config?.flight == false) return;
      if (!Number.isInteger(device?.config?.flight?.id)) return;
      if (this.$root.query.hasOwnProperty("DebugLiveUpdate")) return;

      if (deviceLiveUpdate?.currentFlight?.status != undefined) {
        device.config.flight.data = deviceLiveUpdate.currentFlight.status;
      } else {
        device.config.flight.data = await API.get("flightstatus", {
          CmdId: device.config.flight.id,
        });

        if (device.config.flight?.data?.status !== undefined) {
          let end = false;

          if (device.config.flight?.data.status == "ok") {
            end = true;

            toast.success("Vol terminer", {
              toastId: "flightOk-" + device.config.flight.id,
              closeButton: true,
              autoClose: true,
              closeOnClick: true,
              position: toast.POSITION.TOP_CENTER,
              delay: 10000,
              theme: "dark",
            });
          } else if (device.config.flight?.data?.status == "failed") {
            end = true;

            if (
              device.config.flight?.data?.result !== undefined &&
              device.config.flight.data.result != 0
            ) {
              let errorDJI = API.getFirstData(
                await API.get("djierror", {
                  ErrId: device.config.flight.data.result,
                })
              );

              console.error("errorDJI →", errorDJI);

              if (errorDJI?.dje_texten == undefined) {
                toast.error("Erreur DJI inconnu sur le vol", {
                  toastId: "errorDJI-" + device?.config?.flight?.data?.result,
                  closeButton: true,
                  autoClose: false,
                  closeOnClick: false,
                  position: toast.POSITION.TOP_CENTER,
                  delay: 10000,
                  theme: "dark",
                });
              } else {
                toast.error(errorDJI.dje_texten, {
                  toastId: "errorDJI-" + device?.config?.flight?.data?.result,
                  closeButton: true,
                  autoClose: false,
                  closeOnClick: false,
                  position: toast.POSITION.TOP_CENTER,
                  delay: 10000,
                  theme: "dark",
                });
              }
            }
          }

          if (end) {
            this.clearFlight(device);
          }
        }
      }
    },

    async clearFlight(device) {
      await this.ClearMission(device);

      if (device?.config?.flight == undefined) return;

      device.config.flight = {
        id: null,
        flg_id: null,
        mis_id: null,
        info: {},
        status: {},
        openControlPanel: false,
      };

      device.config?.FlightInit == false;
    },

    async Mission(device) {
      if (!Number.isInteger(device.config.flight.id)) {
        this.ClearMission(device);
        return;
      }

      if (!Number.isInteger(device.config?.flight?.mis_id)) {
        return;
      }

      if (
        device.config?.flight?.mission?.id === device.config.flight.mis_id &&
        device.config?.flight?.mission?.collection !== undefined
      ) {
        return;
      }

      this.ClearMission(device);

      device.config.flight.mission = {};
      device.config.flight.mission.id = device.config.flight.mis_id;

      let mission = API.getFirstData(
        await API.get("mission", {
          MisId: device.config.flight.mis_id,
        })
      );

      device.config.flight.mission = {
        ...device.config.flight.mission,
        ...mission,
      };

      device.config.flight.mission.collection = true;

      let geom = parse(mission.mis_geom);
      Map.dynamicmission.addMission(
        geom ? geom.coordinates : [],
        [],
        mission.mis_text,
        mission.mis_id,
        false
      );
    },

    async ClearMission(device) {
      if (device.config?.flight?.mission?.collection !== undefined) {
        Map.dynamicmission.clear();
        device.config.flight.mission = {};
      }
    },

    /** ------------------- */

    async InitDataDevice(device) {
      if (device == undefined) return;

      let devices = API.getFirstData(
        await API.get("devicefamily", {
          dev_id: device.dev_id,
        })
      );

      device.config = StartConfigDevice(devices, this);
      device.loaded = true;
      device.dataOnload = false;

      this.VideosInit(device);

      if (
        this.$root.isPopup &&
        (device.config.deviceFamilly.this_dev_id ==
          this.$route?.params?.dev_id ||
          device.config.deviceFamilly.drone_dev_id ==
            this.$route?.params?.dev2_id)
      ) {
        device.config.infoType = "popup";
        device.config.reduce = true;
      } else if (
        this.$root.device_aeroscope.hasOwnProperty(
          device?.config?.deviceFamilly?.this_det_id
        )
      ) {
        device.config.infoType = "device_aeroscope";
      } else if (
        !this.$root.device_controller_without_slave.hasOwnProperty(
          device?.config?.deviceFamilly?.this_det_id
        )
      ) {
        if (window.location.search == "?debug=full" || this.$root.debug) {
          device.config.infoType = "full";
        }
      } else {
        device.config.infoType = "device_externe";
      }
    },

    async VideosInit(device) {
      if (device?.dev_id == undefined) return;

      if (
        !this.$root.device_controller.hasOwnProperty(
          device.config.deviceFamilly.this_det_id
        )
      ) {
        return;
      }

      let regex =
        /https?:\/\/[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}:[0-9]{1,9}\//gm;

      let videoPopupDvvId =
        this.$route.name == "Video" ? this.$route.params.dvv_id : false;

      (
        await API.get("video", {
          DevId: device.dev_id,
        })
      ).forEach(async (video) => {
        video.id = video.dvv_webrtc.match(/:8889\/(.*)\//)[1];
        video.open =
          videoPopupDvvId != false ? videoPopupDvvId == video.dvv_id : false;

        video.publish = false;
        video.relaod = false;
        video.read = 0;

        let url = video.dvv_webrtc.replace(
          regex,
          window.location.origin + "/flux/webrtc/"
        );
        video.url = url.endsWith("/") ? url : url + "/";

        let config = await API.get(`videoconfig`, {
          DvvId: video.dvv_id,
        });

        if (config?.len) {
          config.len = config.len.filter((item) => !item.normal);
        }

        video.video_config = config;

        device.config.videos.push(video);
      });

      if (device.config.deviceFamilly?.webcam_dev_id != null) {
        let data = {
          dev_id: device.config.deviceFamilly?.webcam_dev_id,
          dvv_id: device.config.deviceFamilly?.webcam_dev_sn,
          dev_name: device.config.deviceFamilly?.this_name,
          dvv_text: "Webcam",
          isWebcam: true,
          cameradock: true,
          dvv_webrtc:
            "http://IP/" +
            device.config.deviceFamilly?.webcam_dev_sn +
            "/live2",
          url:
            window.location.origin +
            "/flux/webrtc/" +
            device.config.deviceFamilly?.webcam_dev_sn +
            "/live1/",
          id: device.config.deviceFamilly?.webcam_dev_sn,
          open: false,
          publish: false,
          relaod: false,
          read: 0,
        };

        device.config.videos.push(data);
      }
    },

    /** ------------------- */

    async CamDrone(device, devicerawstatus) {
      if (
        device?.config?.camera?.array_index != undefined &&
        devicerawstatus?.cameras != undefined
      ) {
        if (
          devicerawstatus?.cameras[device?.config?.camera?.array_index]
            ?.payload_index != undefined
        ) {
          device.config.camera.payload_index =
            devicerawstatus.cameras[
              device.config.camera.array_index
            ].payload_index;

          device.config.camera.status = {
            ...device.config.camera.status,
            ...devicerawstatus.cameras[device.config.camera.array_index],
          };

          device.config.camera.status.payload_status =
            devicerawstatus[device.config.camera.payload_index];
        }
      }
    },

    async Camera(device, videoStatus) {
      if (videoStatus?.live_status?.length > 0) {
        device.config.camera.status = {
          ...device.config.camera.status,
          ...videoStatus.live_status[0],
        };

        let payloadAsSelected = false;

        videoStatus.live_status.forEach((video) => {
          let video_id = video.video_id;
          let video_id_extract = video_id.match(/\/(.*)\//);
          if (video_id_extract != null) {
            video_id_extract = video_id_extract[1];
          }

          if (video_id_extract == device.config.camera.payload_index) {
            payloadAsSelected = true;
          }
        });

        device.config.camera.payloadAsSelected = payloadAsSelected;
      }
    },

    async VideosInfo(device) {
      if (device.config?.videos == undefined) return;

      device.config.videos.forEach((video) => {
        let r = false;
        video.read = 0;

        if (Object.keys(this.$root.videoStream).length !== 0) {
          this.$root.videoStream.forEach((stream) => {
            if (
              video.dvv_webrtc.includes(stream.path) &&
              stream.state == "publish"
            ) {
              r = true;
            }
            if (
              video.dvv_webrtc.includes(stream.path) &&
              stream.state == "read"
            ) {
              video.read++;
            }
          });
        }

        video.publish = r;

        // video.open = video.cameradock
        //   ? device?.video?.dock?.id == video.id
        //   : device?.video?.drone?.id == video.id;
      });
    },

    async StartVideo(config, video) {
      if (video.publish || video.read > 0) {
        video.open = true;
        return;
      }

      let videos = config.videos.filter((v) => {
        if (video.cameradock == v.cameradock) {
          v.open = false;
        }
        return (
          video.cameradock == v.cameradock &&
          video.dvv_id != v.dvv_id &&
          v.publish
        );
      });

      video.open = true;

      if (videos.length > 0) {
        this.CloseVideos(videos, () => {
          if (video.isWebcam) return;

          this.actionVideo(
            `videoon`,
            {
              DvvId: video.dvv_id,
              isWebcam: video.isWebcam,
            },
            () => {},
            "on"
          );
        });
      } else {
        this.actionVideo(
          `videoon`,
          {
            DvvId: video.dvv_id,
            isWebcam: video.isWebcam,
          },
          () => {},
          "on"
        );
      }
    },

    async CloseVideo(video, finishFunc) {
      video.open = false;
      if (video.read > 1) {
        return;
      }

      this.actionVideo(
        `videooff`,
        {
          DvvId: video.dvv_id,
          isWebcam: video.isWebcam,
        },
        () => {
          finishFunc();
        },
        "off"
      );
    },

    async CloseVideos(videos, finishFunc) {
      videos[0].open = false;
      this.actionVideo(
        `videooff`,
        {
          DvvId: videos[0].dvv_id,
          isWebcam: videos[0].isWebcam,
        },
        () => {
          videos.shift();
          if (videos.length > 0) {
            this.CloseVideos(device, videos);
          } else {
            finishFunc();
          }
        },
        "off"
      );
    },

    async ToggleVideo(config, video) {
      if (video.open) {
        this.CloseVideo(video, () => {});
        return;
      } else {
        this.StartVideo(config, video);
        return;
      }
    },

    async ReloadVideo(video) {
      this.actionVideo(
        `videooff`,
        {
          DvvId: video.dvv_id,
          isWebcam: video.isWebcam,
        },
        () => {
          this.actionVideo(
            `videoon`,
            {
              DvvId: video.dvv_id,
              isWebcam: video.isWebcam,
            },
            () => {
              video.relaod = false;
            },
            "on"
          );
        },
        "off"
      );
    },

    async OpenPopup(config, video) {
      toast.info("Ouverture de la fenêtre", this.$root.toastConfig);

      this.$router.getRoutes().forEach((route) => {
        if (route.name == "APP_POPUP") {
          let path = route.path.replace(
            ":dev_id(\\d+)",
            config.deviceFamilly.this_dev_id
          );

          const newTab = window.open(window.location.origin + path, "_blank");
          if (newTab) {
            newTab.focus();
          } else {
            toast.error(
              "Veuillez autoriser les fenêtres pop-up pour cette page",
              this.$root.toastConfig
            );
          }
        }
      });
    },

    async OpenPopupOnCurrentPage(config, video) {
      toast.info("Ouverture de la fenêtre", this.$root.toastConfig);

      this.$router.getRoutes().forEach((route) => {
        if (route.name == "APP_POPUP_MILESTONE") {
          let path = route.path.replace(
            ":dev_id(\\d+)",
            config.deviceFamilly.this_dev_id
          );

          this.$router.push(path);
          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
      });
    },

    async actionVideo(api_call, params, fonc, type) {
      if (params.isWebcam) {
        fonc();
        return;
      }

      let data = await API.put(api_call, params);

      this.$root.msg_replie[data.command] = {
        id: data.command,
        function: async (data) => {
          if (StartVideoResult(data?.result, type)) {
            delete this.$root.msg_replie[data.command];
            fonc();
          } else if (data?.result != null && data?.result != undefined) {
            delete this.$root.msg_replie[data.command];

            if (data?.result == 513001) {
              data.result = `Erreur de diffusion en direct (#513001) – L'appareil est déconnecter ou introuvable.`;
            } else if (data?.result == 613012) {
              data.result = `Erreur de diffusion en direct (#613012) – Une autre transmission vidéo est déjà en cours. Malheureusement, il n'est pas possible de passer directement d'un flux à l'autre pendant une diffusion en direct.`;
            } else if (data?.result == 613012) {
              data.result = `Erreur de diffusion en direct (#613012) – Une autre transmission vidéo est déjà en cours. Malheureusement, il n'est pas possible de passer directement d'un flux à l'autre pendant une diffusion en direct.`;
            } else if (data?.result != undefined) {
              let r = API.getFirstData(
                await API.get(`djierror`, {
                  ErrId: data.result,
                })
              );

              if (r?.dje_texten != undefined) {
                data.result = r.result;
              } else if (r?.dje_textcn != undefined) {
                data.result = r.result;
              }
            }

            if (data?.result == undefined) {
              data.result = "Erreur inconnu sur la diffusion en direct";
            }

            toast.error(data.result, this.$root.toastConfig);
          }
        },
      };
    },

    /** ------------------------ */

    debugDevices(devices) {
      if (!this.$root.query.hasOwnProperty("OverWriteLiveUpdate")) {
        return devices;
      }

      return LiveUpdateJSON;
    },
  },
};
</script>
